<script>
import Endpoints from '../../../components/common/Endpoints'
import Common from '../../../components/common/Common'
import Request from '../../../components/common/Request'

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN'
    if (geo.geometry.lat) {
        addressObj.lat = geo.geometry.lat
    } else return null
    if (geo.geometry.lng) {
        addressObj.lng = geo.geometry.lng
    } else return null

    return addressObj
}

export default {
    init: async payload => {
        payload.domain = Endpoints.domain

        let resultTags = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listGasStationTags}`)        
        payload.tags = resultTags.data.results
    },

    methods: {
        save: function () {
            this.errors = []
            this.messageIdToast = null
            let state = this
            let data = state.data

            data.document = state.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')

            if (state.data.mainCompany) {
                data.mainCompany = state.data.mainCompany.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
            }

            const fuel = state.data.fuels

            if (fuel.gnv) {
                fuel.gnv = fuel.gnv.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.gas) {
                fuel.gas = fuel.gas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.premmiumGas) {
                fuel.premmiumGas = fuel.premmiumGas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.additiveGas) {
                fuel.additiveGas = fuel.additiveGas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.ethanol) {
                fuel.ethanol = fuel.ethanol.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.premmiumEthanol) {
                fuel.premmiumEthanol = fuel.premmiumEthanol.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.diesel) {
                fuel.diesel = fuel.diesel.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.dieselS10) {
                fuel.dieselS10 = fuel.dieselS10.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.dieselS500) {
                fuel.dieselS500 = fuel.dieselS500.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.electricity) {
                fuel.electricity = fuel.electricity.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }

            data.fuels = fuel

            let formData = new FormData()
            formData.append('file', this.file)
            formData.append('jsonData', JSON.stringify(data))

            Request.do(
                state,
                state.data._id ? 'PUT' : 'POST',
                Request.getDefaultHeader(state),
                formData,
                `${Endpoints.companies.companyFormData}${state.data._id ? state.data.document : ''}`,
                response => {
                    this.$eventHub.$emit('refreshList')

                    //SUCCESS CALLBACK
                    if (this.data._id) {
                        this.flashMessage.info(this.configMessage(this.$t('string.msg.register.title.alter'), this.$t('string.msg.gas.station.updated.message.success'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.gas.station.updated.message.success')),
                            destroyed: this.clearText(),
                        })
                    } else {
                        this.flashMessage.info(this.configMessage(this.$t('string.msg.register.title.success'), this.$t('string.msg.gas.station.register.message.success'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.gas.station.register.message.success')),
                            destroyed: this.clearText(),
                        })
                    }

                    state.data.logoURL = response.result.logoURL
                    state.data._id = response.result._id
                    state.valuekey += 1
                },
                error => {
                    //ERROR CALLBACK
                    $('#spinner').modal('toggle')
                    let res = error.response
                    if (res && res.status) {
                        this.titleToast = this.$t('string.msg.warning')
                        if (res.data.messageId === 'response.msg.error.empty.fields') {
                            let fields = ''
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id) + ';<br/>'
                            })
                            this.titleToast = this.$t(res.data.messageId)
                            this.messageToast = this.$t(fields)
                        } else {
                            this.messageToast = this.$t(res.data.messageId)
                            this.messageIdToast = res.data.messageId
                        }
                        $('#toast').modal('show')
                    }
                },
            )
        },
        getAddressData: function (geo, placeResultData) {
            const locale = {
                address: placeResultData.formatted_address,
                geolocation: {
                    latitude: geo.latitude,
                    longitude: geo.longitude,
                },
            }

            this.data.locale = locale
        },
        getPlaces(keyword) {
            Request.do(
                this,
                'GET',
                Request.getDefaultHeader(this),
                null,
                `${Endpoints.addresses.places.search}${keyword}`,
                response => {
                    //SUCCESS CALLBACK
                    this.places = response.results
                },
                error => {
                    //ERROR CALLBACK
                    console.log(error)
                },
            )
        },
        archive: function (response) {
            if (response == 1) {
                $('#spinner').modal('toggle')
                this.errors = []
                this.messageIdToast = null
                let state = this
                this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
                Request.do(
                    this,
                    'DELETE',
                    Request.getDefaultHeader(this),
                    this.data,
                    `${Endpoints.companies.company}${this.data.document ? this.data.document : ''}`,
                    companyResponse => {
                        //SUCCESS CALLBACK
                        $('#spinner').modal('toggle')
                        this.$eventHub.$emit('refreshList')
                        this.flashMessage.warning(this.configMessage(this.$t('string.msg.company.register.title.filed'), this.$t('string.msg.gas.station.archived.message.success'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.gas.station.archived.message.success')),
                            destroyed: this.clearText(),
                        })
                    },
                    error => {
                        //ERROR CALLBACK
                        $('#spinner').modal('toggle')
                        let res = error.response
                        if (res && res.status) {
                            this.titleToast = this.$t('string.msg.warning')
                            if (res.data.messageId === 'response.msg.error.empty.fields') {
                                let fields = ''
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id) + ';<br/>'
                                })
                                this.titleToast = this.$t(res.data.messageId)
                                this.messageToast = this.$t(fields)
                            } else {
                                this.messageToast = this.$t(res.data.messageId)
                                this.messageIdToast = res.data.messageId
                            }

                            $('#toast').modal('show')
                        }
                        console.log(JSON.stringify(error))
                    },
                )
            }
        },
        confirmArchive: function (item) {
            this.titleToast = this.$t('string.msg.confirm')
            this.messageToast = this.$t('response.archive.company.confirmation')
            this.cancelText = this.$t('string.msg.cancel')
            this.yesText = this.$t('string.msg.yes')
            $('#confirmationModal').modal('show')
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.data.address,
                `${Endpoints.addresses.geolocation}`,
                geoResponse => {
                    //SUCCESS CALLBACK
                    if (geoResponse.results.length == 0) {
                        return callbackError(this.$t('string.company.register.address.invalid'))
                    } else if (geoResponse.results.length == 1) {
                        let geo = geoResponse.results[0]
                        let addressObj = instanceateAddress(state.data.address, geoResponse.results[0])
                        if (addressObj) {
                            return callbackSuccess(state.data)
                        } else {
                            // state.data.address
                            return callbackError(state.$t('string.company.register.address.invalid'))
                        }
                    } else if (geoResponse.results.length > 1) {
                        state.addresses = geoResponse.results
                        $('#modalListAddress').modal('toggle')
                    }
                },
                error => {
                    //ERROR CALLBACK
                    let res = error.response
                    if (res && res.status) {
                        this.titleToast = this.$t('string.msg.warning')
                        if (res.data.messageId === 'response.msg.error.empty.fields') {
                            let fields = ''
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id) + ';<br/>'
                            })
                            this.titleToast = this.$t(res.data.messageId)
                            this.messageToast = this.$t(fields)
                        } else if (res.data.messageId === 'response.already.exists') {
                            this.messageToast = this.$t('response.user.already.exists')
                        } else {
                            this.messageToast = this.$t(res.data.messageId)
                            this.messageIdToast = res.data.messageId
                        }

                        $('#toast').modal('show')
                    }
                },
            )
        },
        selectAddress: function (index) {
            let addressObj = instanceateAddress(this.data.address, this.addresses[index])

            if (addressObj) {
                addressObj.ibge = this.data.address.ibge
                addressObj.gia = this.data.address.gia
                addressObj.complement = this.data.complement
                this.data.address = addressObj
                $('#modalListAddress').modal('toggle')
                this.save()
            } else {
                this.errors = []
                this.errors.push(this.$t('string.company.register.address.invalid'))
                $('#modalListAddress').modal('toggle')
            }
        },
        loadInfosByCEP: function () {
            let state = this
            if (this.data.address.cep && this.data.address.cep.length == 9) {
                $('#spinner').modal('toggle')
                Request.do(
                    this,
                    'GET',
                    {},
                    {},
                    `${Endpoints.cep.find}${this.data.address.cep}/json`,
                    response => {
                        //SUCCESS CALLBACK
                        if (response) {
                            state.data.address.address = response.logradouro
                            state.data.address.neighborhood = response.bairro
                            state.data.address.city = response.localidade
                            state.data.address.state = response.uf
                            state.data.address.ibge = response.ibge
                            state.data.address.gia = response.gia
                        }

                        $('#spinner').modal('toggle')
                    },
                    error => {
                        //ERROR CALLBACK
                        $('#spinner').modal('toggle')

                        console.log(JSON.stringify(error))
                    },
                )
            }
        },
        checkForm: function (e) {
            this.errors = []
            if (!this.data.fantasyName) {
                this.errors.push(this.$t('response.user.register.fantasyName.required'))
            }
            if (!this.data.socialName) {
                this.errors.push(this.$t('response.user.register.socialName.required'))
            }
            if (!this.data.document) {
                this.errors.push(this.$t('response.user.register.document.required'))
            }

            // if (this.data.isBranch && !this.data.mainCompany) {
            //     this.errors.push(this.$t('response.user.register.document.maincompany'))
            // }

            if (this.errors.length > 0) {
                e.preventDefault()
            } else {
                this.save()
            }
        },
        selectItem: function (item) {
            this.data = JSON.parse(JSON.stringify(item))
            this.data.fantasyName = Common.camelize(this.data.fantasyName)
            this.data.socialName = Common.camelize(this.data.socialName)
            this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')

            this.data.fuels.gnv = Number(this.data.fuels.gnv).toFixed(2)
            this.data.fuels.gas = Number(this.data.fuels.gas).toFixed(2)
            this.data.fuels.premmiumGas = Number(this.data.fuels.premmiumGas).toFixed(2)
            this.data.fuels.additiveGas = Number(this.data.fuels.additiveGas).toFixed(2)
            this.data.fuels.ethanol = Number(this.data.fuels.ethanol).toFixed(2)
            this.data.fuels.premmiumEthanol = Number(this.data.fuels.premmiumEthanol).toFixed(2)
            this.data.fuels.diesel = Number(this.data.fuels.diesel).toFixed(2)
            this.data.fuels.dieselS10 = Number(this.data.fuels.dieselS10).toFixed(2)
            this.data.fuels.dieselS500 = Number(this.data.fuels.dieselS500).toFixed(2)
            this.data.fuels.electricity = Number(this.data.fuels.electricity).toFixed(2)

            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout(() => (this.text = ''), 500)
        },
        clearForm: function () {
            this.data = {
                status: 'ACTIVE',
                isBranch: false,
                fantasyName: null,
                socialName: null,
                email: null,
                document: null,
                photoURL: 'https://',
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
                tags: [],
                fuels: {
                    gnv: null,
                    gas: null,
                    premmiumGas: null,
                    additiveGas: null,
                    ethanol: null,
                    premmiumEthanol: null,
                    diesel: null,
                    dieselS10: null,
                    dieselS500: null,
                    electricity: null,
                },
                primaryPhone: null,
                secondaryPhone: null,
                talkTo: null,
                typeService: ['GAS_STATION'],
            }
            this.errors = []
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0]
        },
        listManufacturer: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listFamilies: function (item) {
            return item.families.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listManufacturerTruck: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK')
        },
        listFamiliesTruck: function (item) {
            return item.families.filter(i => i.type === 'TRUCK')
        },

        selectAll: function () {
            if (!this.isAllSelected) {
                let state = this
                this.data.families = []
                this.families.forEach(function (item) {
                    if (item && item._id) state.data.families.push(item._id)
                })
                this.isAllSelected = true
            } else {
                this.data.families = []
                this.isAllSelected = false
            }
        },
        configMessage: function (title, message, position, time) {
            const config = {
                title: title,
                message: message,
                position: position,
                x: window.innerWidth / 60,
                y: window.innerHeight / 1.3,
                time: time,
            }
            return config
        },
        camelize: Common.toUpperCase,
    },
}
</script>
